/*
 * PanelPartners — Offerte-aanvraag ("quote cart").
 * Los offerte-mandje in localStorage, los van de gewone winkelwagen.
 * - PDP-knop voegt product + aantal toe.
 * - Modal toont de producten + contactformulier.
 * - Versturen gaat via het Shopify contactformulier (e-mail naar de winkel).
 * - Blijft bewaard tijdens het shoppen; teller staat in de header.
 */
(function () {
  var KEY = 'pp_quote_items';

  /* ---------- State ---------- */
  function load() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function save(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
    sync();
  }
  function items() { return load(); }
  function count() {
    return load().length;
  }

  function addItem(item) {
    var list = load();
    var existing = list.filter(function (it) { return String(it.variantId) === String(item.variantId); })[0];
    if (existing) {
      existing.qty = (parseInt(existing.qty, 10) || 0) + (parseInt(item.qty, 10) || 1);
    } else {
      list.push(item);
    }
    save(list);
  }
  function removeItem(variantId) {
    save(load().filter(function (it) { return String(it.variantId) !== String(variantId); }));
  }
  function setQty(variantId, qty) {
    var list = load();
    list.forEach(function (it) {
      if (String(it.variantId) === String(variantId)) it.qty = Math.max(1, parseInt(qty, 10) || 1);
    });
    save(list);
  }
  function clear() { save([]); }

  /* ---------- DOM helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var modal;
  var savedScrollY = 0;

  // iOS Safari negeert overflow:hidden op <html>/<body> voor touch-scroll, dus
  // de pagina bleef achter de modal meebewegen (in beide richtingen). De
  // betrouwbare lock is de body op position:fixed zetten met de huidige
  // scrollpositie als negatieve top, en die bij sluiten terugzetten.
  function lockScroll() {
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = -savedScrollY + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    document.documentElement.style.overflow = 'hidden';
  }
  function unlockScroll() {
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    document.documentElement.style.overflow = '';
    window.scrollTo(0, savedScrollY);
  }

  function openModal() {
    modal = modal || $('#pp-quote-modal');
    if (!modal) return;
    resetModal();
    renderItems();
    modal.classList.add('is-open');
    lockScroll();
    modal.setAttribute('aria-hidden', 'false');
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    unlockScroll();
    modal.setAttribute('aria-hidden', 'true');
  }

  function renderItems() {
    var wrap = $('[data-pp-quote-items]');
    var empty = $('[data-pp-quote-empty]');
    var submitBtn = $('[data-pp-quote-submit]');
    if (!wrap) return;
    var list = load();
    wrap.innerHTML = '';
    if (!list.length) {
      if (empty) empty.style.display = '';
      if (submitBtn) submitBtn.disabled = true;
      return;
    }
    if (empty) empty.style.display = 'none';
    if (submitBtn) submitBtn.disabled = false;

    list.forEach(function (it) {
      var row = document.createElement('div');
      row.className = 'pp-quote__item';
      row.innerHTML =
        '<div class="pp-quote__item-media">' +
          (it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '') +
        '</div>' +
        '<div class="pp-quote__item-info">' +
          '<span class="pp-quote__item-title">' + escapeHtml(it.title) +
            (it.variantTitle && it.variantTitle !== 'Default Title' ? ' – ' + escapeHtml(it.variantTitle) : '') +
          '</span>' +
          (it.sku ? '<span class="pp-quote__item-sku">SKU: ' + escapeHtml(it.sku) + '</span>' : '') +
          (it.price ? '<span class="pp-quote__item-price">' + escapeHtml(it.price) + '</span>' : '') +
        '</div>' +
        '<div class="pp-quote__item-qty">' +
          '<button type="button" class="pp-quote__qtybtn" data-pp-qty-dec aria-label="Minder">−</button>' +
          '<input type="text" inputmode="numeric" class="pp-quote__qtyinput" value="' + (parseInt(it.qty, 10) || 1) + '" aria-label="Aantal">' +
          '<button type="button" class="pp-quote__qtybtn" data-pp-qty-inc aria-label="Meer">+</button>' +
        '</div>' +
        '<button type="button" class="pp-quote__remove" data-pp-remove aria-label="Verwijderen">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
        '</button>';
      row.setAttribute('data-variant', it.variantId);
      wrap.appendChild(row);
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Header + PDP button sync ---------- */
  function sync() {
    var c = count();
    $all('[data-pp-quote-count]').forEach(function (el) { el.textContent = c; });
    $all('[data-pp-quote-open]').forEach(function (el) {
      if (c > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
    // PDP buttons: change label if the quote already has items
    var hasItems = load().length > 0;
    $all('[data-pp-quote-add]').forEach(function (btn) {
      var t = $('.bulk-quote__cta-text', btn);
      if (!t) return;
      t.textContent = hasItems ? (btn.getAttribute('data-added-text') || '+ Voeg toe aan offerte')
                               : (btn.getAttribute('data-default-text') || 'Vraag een offerte aan');
    });
    if (modal && modal.classList.contains('is-open')) renderItems();
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#pp-quote-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Add from PDP ---------- */
  function handleAdd(btn) {
    var section = btn.getAttribute('data-section');
    var qtyInput = section ? document.getElementById('Quantity-' + section) : null;
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    var variants = [];
    try { variants = JSON.parse(btn.getAttribute('data-variants') || '[]'); } catch (e) {}
    var form = section ? document.getElementById('product-form-' + section) : null;
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var variantId = idInput ? idInput.value : (variants[0] && variants[0].id);
    var variant = variants.filter(function (v) { return String(v.id) === String(variantId); })[0] || variants[0] || {};

    if (!variant.id) return;

    addItem({
      variantId: variant.id,
      title: btn.getAttribute('data-product-title') || '',
      variantTitle: variant.title || '',
      sku: variant.sku || '',
      price: variant.price || '',
      qty: qty,
      url: btn.getAttribute('data-product-url') || '',
      image: btn.getAttribute('data-product-image') || ''
    });

    openModal();
  }

  /* ---------- Submit via Shopify contact form ---------- */
  function lineFor(it) {
    return (parseInt(it.qty, 10) || 1) + '× ' + it.title +
      (it.variantTitle && it.variantTitle !== 'Default Title' ? ' (' + it.variantTitle + ')' : '') +
      (it.sku ? ' — SKU: ' + it.sku : '') +
      (it.price ? ' — ' + it.price + ' p/st' : '');
  }

  /* Verzenden loopt via het ECHTE Shopify contactformulier (PPQuoteForm) met een
     native submit-knop, zodat Shopify's hCaptcha-afhandeling meeloopt en een geldig
     token meestuurt. Wij injecteren hier alleen de productregels vlak vóór verzending
     en laten de submit daarna gewoon doorgaan (full-page). Bij terugkomst
     (?contact_posted=true) tonen we de succesmelding en legen we het mandje. */
  function onFormSubmit(e) {
    var form = e.target;
    if (!form || form.id !== 'PPQuoteForm') return;
    var emailInput = form.querySelector('[name="contact[email]"]');
    var list = load();
    if (!emailInput || !emailInput.value || !emailInput.checkValidity()) {
      e.preventDefault();
      if (emailInput) { emailInput.focus(); emailInput.reportValidity && emailInput.reportValidity(); }
      return;
    }
    if (!list.length) { e.preventDefault(); return; }

    $all('[data-pp-injected]', form).forEach(function (n) { n.remove(); });
    var total = 0;
    list.forEach(function (it, i) {
      addHidden(form, 'contact[Product ' + (i + 1) + ']', lineFor(it));
      total += parseInt(it.qty, 10) || 1;
    });
    addHidden(form, 'contact[Totaal aantal stuks]', String(total));
    addHidden(form, 'contact[Type aanvraag]', 'Offerte-aanvraag via website');

    try { sessionStorage.setItem('pp_quote_pending', '1'); } catch (err) {}

    var submitBtn = $('[data-pp-quote-submit]');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Versturen...'; }
    // GEEN preventDefault — Shopify's hCaptcha + full-page submit handelen af.
  }

  function checkReturn() {
    try {
      if (location.search.indexOf('contact_posted=true') > -1 && sessionStorage.getItem('pp_quote_pending')) {
        sessionStorage.removeItem('pp_quote_pending');
        clear();
        if (history.replaceState) history.replaceState(null, '', location.pathname);
        openModal();
        showSuccess();
      }
    } catch (err) {}
  }

  function addHidden(form, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.setAttribute('data-pp-injected', '');
    form.appendChild(input);
  }

  function showSuccess() {
    var body = $('[data-pp-quote-body]');
    var success = $('[data-pp-quote-success]');
    if (body) body.style.display = 'none';
    if (success) success.style.display = '';
  }
  function resetModal() {
    var body = $('[data-pp-quote-body]');
    var success = $('[data-pp-quote-success]');
    if (body) body.style.display = '';
    if (success) success.style.display = 'none';
    var submitBtn = $('[data-pp-quote-submit]');
    if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Offerte aanvragen'; }
  }

  /* ---------- Events ---------- */
  function onClick(e) {
    var addBtn = e.target.closest && e.target.closest('[data-pp-quote-add]');
    if (addBtn) { e.preventDefault(); handleAdd(addBtn); return; }

    if (e.target.closest && e.target.closest('[data-pp-quote-open]')) { e.preventDefault(); resetModal(); openModal(); return; }
    // Klik op de achtergrond (de modal-container zelf, buiten het paneel) sluit.
    if (e.target && e.target.id === 'pp-quote-modal') { closeModal(); return; }
    if (e.target.closest && e.target.closest('[data-pp-quote-close]')) { e.preventDefault(); closeModal(); return; }
    if (e.target.closest && e.target.closest('[data-pp-quote-save]')) { e.preventDefault(); closeModal(); toast('Offerte opgeslagen'); return; }

    var row = e.target.closest && e.target.closest('.pp-quote__item');
    if (row) {
      var vid = row.getAttribute('data-variant');
      if (e.target.closest('[data-pp-remove]')) { removeItem(vid); return; }
      if (e.target.closest('[data-pp-qty-inc]')) { bumpQty(row, vid, 1); return; }
      if (e.target.closest('[data-pp-qty-dec]')) { bumpQty(row, vid, -1); return; }
    }
  }

  function bumpQty(row, vid, delta) {
    var input = $('.pp-quote__qtyinput', row);
    var cur = input ? (parseInt(input.value, 10) || 1) : 1;
    setQty(vid, cur + delta);
  }

  function onInput(e) {
    var input = e.target.closest && e.target.closest('.pp-quote__qtyinput');
    if (!input) return;
    var row = input.closest('.pp-quote__item');
    if (!row) return;
    var vid = row.getAttribute('data-variant');
    var v = parseInt(input.value.replace(/[^0-9]/g, ''), 10);
    if (v && v > 0) setQty(vid, v);
  }

  function init() {
    document.addEventListener('click', onClick);
    document.addEventListener('change', onInput);
    document.addEventListener('submit', onFormSubmit, true); // capture: injecteer regels vóór Shopify's handler
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    sync();
    checkReturn();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
